import { useState } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import {
  ThemeProvider as DSThemeProvider,
  useTheme,
} from "@gcs/design-system/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "style/main.css";
import Header from "components/common/Header";
import Footer from "components/common/Footer";
import Navigator from "components/Navigator";
import RedirectToTrainingFile from "components/common/RedirectToTrainingFile/RedirectToTrainingFile";

import AppContext from "context/AppContext";
import { GoogleAnalytics } from "components/GoogleAnalytics/GoogleAnalytics";

import Home from "pages/Home";
import Ombudsman from "pages/Ombudsman";
import CnpHolding from "pages/CnpHolding";
import ComplianceAndGovernance from "pages/ComplianceAndGovernance";
import Sponsorship from "pages/Sponsorship";
import CnpAssurance from "pages/CnpAssurance";
import Newsroom from "pages/Newsroom";
import CorporativeCulture from "pages/CorporativeCulture";
import Achievements from "pages/Achievements";
import ModalExpiratedToken from "components/ModalExpiratedToken/ModalExpiratedToken";

const App = () => {
  const theme = "cnp-assurances";
  const [context, setContext] = useState({
    setContext: (newCtx) => {
      setContext((oldCtx) => ({ ...oldCtx, ...newCtx }));
    },
    navigateTo: window.location.pathname,
    showCookiesModal: false,
    showCookieDisclaimer: false,
  });

  return (
    <AppContext.Provider value={context}>
      <DSThemeProvider theme={theme}>
        <ThemeProvider theme={useTheme(theme)}>
          <BrowserRouter>
            <Header />
            <main>
              <Switch>
                <Route exact path="/ouvidoria" component={Ombudsman} />
                <Route
                  exact
                  path="/cnp-seguros-holding-brasil"
                  component={CnpHolding}
                />
                <Route
                  exact
                  path="/conformidade"
                  component={ComplianceAndGovernance}
                />
                <Route exact path="/patrocinios" component={Sponsorship} />
                <Route exact path="/cnp-assurances" component={CnpAssurance} />
                <Route exact path="/imprensa" component={Newsroom} />
                <Route
                  exact
                  path="/cultura-corporativa"
                  component={CorporativeCulture}
                />
                <Route exact path="/conquistas" component={Achievements} />
                <Route
                  exact
                  path="/treinamento-fornecedores"
                  component={RedirectToTrainingFile}
                />
                <Route path="/" component={Home} />

                <Redirect from="*" to="/" />
              </Switch>
              <Navigator />
            </main>
            <GoogleAnalytics />
          </BrowserRouter>
          <Footer />

          <ModalExpiratedToken />
        </ThemeProvider>
      </DSThemeProvider>
    </AppContext.Provider>
  );
};

export default App;
